import Ajax from '@/lib/ajax'
export default {
    /**
     * 创建营销活动
     * @param data 
     */
    addPromotionActivity(data: any) {
        return Ajax.post(`/api/MarketingManagement/PromotionActivity`, data)
    },
    /**
     * 更新营销活动
     * @param id 
     * @param data 
     */
    updatePromotionActivity(id: string, data: any) {
        return Ajax.put(`/api/MarketingManagement/PromotionActivity/${id}`, data)
    },
    /**
     * 获取营销活动详情
     * @param id 
     */
    getPromotionActivity(id: string) {
        return Ajax.get(`/api/MarketingManagement/PromotionActivity/${id}`)
    },
    /**
     * 获取商品设置
     * @param id 
     */
    getProductFilter(id: string) {
        return Ajax.get(`/api/MarketingManagement/PromotionActivity/productfilter/${id}`)
    },
    /**
     * 更新商品设置
     * @param id 
     * @param data 
     */
    updateProductFilter(id: string, data: any) {
        return Ajax.put(`/api/MarketingManagement/PromotionActivity/productfilter/${id}`, data)
    },

    /**
     * 获取营销活动列表
     * @param MaxResultCount 
     * @param SkipCount 
     * @param Type 
     * @param KeyWord 
     * @param Sorting 
     */
    getActivityList(MaxResultCount: number, currentPage: number, Type?: string, KeyWord?: string, Sorting?: string, Status?: number, ExcludeUnPublished?:boolean) {
        return Ajax.get(`/api/MarketingManagement/PromotionActivity`, {
            params: {
                MaxResultCount,
                SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
                Type,
                KeyWord,
                Sorting,
                Status,
                ExcludeUnPublished
            }
        })
    }
}